// Row contract of an agent's knowledge source (DOCS-KB; `cell.agent_knowledge_source`). Same
// conventions as `work-rows.ts`: keys are column names, nullability is the column's, enums are
// the CHECK's; `contract-drift.test.ts` binds it to its table.
import { z } from "zod";
import { ActorShortColumns } from "./actor";
import { KnowledgeSourceKind, PageKind } from "./enums";
import { Timestamp, Uuid } from "./primitives";

export const AgentKnowledgeSource = z
  .object({
    company_id: Uuid,
    id: Uuid,
    agent_membership_id: Uuid,
    source_kind: KnowledgeSourceKind,
    page_id: Uuid.nullable(),
    space_id: Uuid.nullable(),
    page_kind: PageKind.nullable(),
    last_read_at: Timestamp.nullable(),
    ...ActorShortColumns.shape,
    created_at: Timestamp,
    updated_at: Timestamp,
  })
  .meta({ id: "AgentKnowledgeSource" });
export type AgentKnowledgeSource = z.infer<typeof AgentKnowledgeSource>;
